import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { Link } from "react-router-dom";
import constants from "../constants/constants";
import NavigationMenu from "./navigationMenu";

export default function Footer() {
  const [activeMenu, setActiveMenu] = useState(null);
  const [menus, setMenus] = useState({
    buying: false,
    selling: false,
    info: false,
  });
  function setDropdown(key) {
    var temp = { ...menus };
    for (let k of Object.keys(temp)) {
      if (key === k) {
        temp[k] = !temp[k];
      } else {
        temp[k] = false;
      }
    }

    setMenus(temp);
  }

  const handleMenuClick = (menu) => {
    setActiveMenu(activeMenu === menu ? null : menu);
  };

  return (
    <div className="bg-logo-main w-full py-12 px-16 flex flex-wrap gap-x-20 gap-y-10 justify-between">
      <div className="grid md:grid-cols-2 gap-x-24 w-fit gap-y-3 font-semibold child:relative mt-2 text-white">
        <div className="flex flex-col gap-y-3">
          {constants.NAV_ITEMS.filter((item) => !item.items.length).map((item) => (
            <Link key={item.label} to={item.href}>
              {item.label}
            </Link>
          ))}
        </div>
        <div className="flex flex-col gap-y-3">
          {constants.NAV_ITEMS.filter((item) => item.items.length > 0).map((item) => (
            <div
              key={item.label}
              className="cursor-pointer"
              onClick={() => handleMenuClick(item.label)}
            >
              {item.label}
              <FontAwesomeIcon
                icon={faAngleDown}
                className={`ml-2 ${
                  activeMenu === item.label ? "fa-flip-vertical" : ""
                }`}
              />
              {activeMenu === item.label && (
                <NavigationMenu items={[...item.items]} />
              )}
            </div>
          ))}
        </div>
      </div>
      <div className="flex flex-col items-end">
        <h1 className="text-2xl text-white pb-8 font-mont">FOLLOW</h1>
        <div className="flex gap-x-5 my-2">
          {Object.entries(constants.SOCIALS).map(([key, url]) => (
            <a key={key} href={url} target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon
                className="fa-xl text-white"
                icon={constants.ICONS[key]}
              />
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}
